import React, { Suspense, useEffect, useState } from 'react'
import { Card, CardBody, CardHeader, Row, Col } from "reactstrap";
import {
  Redirect,
  Route,
  Switch
} from 'react-router-dom'
import { CContainer, CFade } from '@coreui/react'

import accessMenu from './access-menu'

import routes from '../routes'
import { NewsModel } from "../models";
import { NewsDetailModal } from "../components/modals";

const news_model = new NewsModel();

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

const TheContent = ({ NOTIFY, PERMISSIONS, USER, COMPANY_INFO }) => {
  const [show, setShow] = useState(false)
  const [newsList, setNewsList] = useState()
  const [newsCode, setNewsCode] = useState('')
  const [newsDetail, setNewsDetail] = useState('')

  const fetch = async () =>{
    const result = await news_model.getNewsBy()
    setNewsList(result.data)
    setShow(false)
    setNewsCode('')
    setNewsDetail('')
  }
  useEffect(()=>{
    fetch()
  },[])

  const _generatePermission = (data) => PERMISSIONS.find(item => item.menu_name_en === data.key) || {
    permission_view: true,
    permission_add: true,
    permission_edit: true,
    permission_approve: true,
    permission_cancel: true,
    permission_delete: true,
    permission_print: true,
  }

  const navigation = accessMenu({ NOTIFY, PERMISSIONS, }).find(val => val._tag === 'CSidebarNavItem')
  const openNewsDetailModal = (news_code, news_detail) => {
    setShow(true)
    setNewsCode(news_code)
    setNewsDetail(news_detail)
  }
  return (
    <main className="c-main">
      <CContainer fluid>
        <Suspense fallback={loading}>
          <Switch>
            {routes.map((route, idx) => { 

              return route.component ? (
                <Route
                  key={idx}
                  path={route.path}
                  exact={route.exact}
                  name={route.name}
                  render={props => (
                    <CFade>
                      <route.component {...props} 
                      session={{ 
                        NOTIFY, 
                        PERMISSION: _generatePermission({ key: route.key, }),
                        USER,
                        COMPANY_INFO,
                        }} />
                    </CFade>
                  )}
                />
              ) 
              :
              (
              <Card>
              <CardHeader>
                <h3 className="mb-0">รายละเอียดข่าวสาร / News Detail</h3>
              </CardHeader>
              <CardBody> 
                {newsList && newsList.length > 0 && newsList.map((item, idx) => (
                  <Card key={idx}>
                    <CardBody>
                      <Row>
                        <Col md={11}>
                          <div
                            style={{
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 3,
                              overflow: "hidden",
                            }}
                          >
                            {item.news_detail}
                          </div>
                        </Col>
                        <Col md={1}>
                          <div className="float text-right">
                            <button
                              type="button"
                              className="icon-button color-primary"
                              onClick={()=> openNewsDetailModal(item.news_code, item.news_detail)}
                            >
                              <i className="fa fa-search" aria-hidden="true" />
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                ))}
              </CardBody>
            </Card>
            )
            })}
            <Redirect from={'/'} to={navigation ? navigation.to : '/'} />
          </Switch>
        </Suspense>
      </CContainer>
      <NewsDetailModal
          show={show}
          news_code={newsCode}
          news_detail={newsDetail}
          onClose={() => setShow(false)}
        />
    </main>
    
  )
}

export default React.memo(TheContent)